/* =====================================================================
 * Zuhause-Koordinaten-Poster Editor (PROJ-39)
 * =====================================================================
 * Reines Text-Poster (KEIN Foto, KEIN Crop, KEIN Karten-Element).
 * Kopiervorlage = geburtsposter.js + Adresssuche nach dem Stadtkarten-/
 * Apparel-Muster (Google Places Autocomplete, Retry bis API geladen).
 *
 * PRINT-MATCH: Die Live-Vorschau spiegelt renderZuhause() aus
 * citymap-server/blanket_frontend/print-mode.js 1:1. DMS-Konvertierung
 * passiert NUR HIER (Dezimal->DMS bei Treffer-Auswahl); der String im
 * Koordinatenfeld geht verbatim in Vorschau UND Druck - der Server
 * konvertiert nichts (DMS/Dezimal-Fehlerklasse strukturell vermieden).
 *
 * Orientierung: Toggle nach photo.js-Muster (Fotoposter/Stadtkarte) -
 * Varianten bleiben Hochformat-Labels (30x40 etc.), bei Querformat wird
 * NUR print.width/height getauscht. Posterflow-SKU ist orientierungslos.
 * ===================================================================== */

(function () {
  'use strict';

  var BACKEND_API_URL = window.ZH_BACKEND_API_URL || 'https://tiles.distantlines.de';

  /* ---- Geteilte Layout-Konstanten (MUESSEN dem Server entsprechen) ---- */
  var INK = '#28292d';
  var SANS = "'Outfit', system-ui, sans-serif";
  /* Stil-Fonts Modern/Elegant/Verspielt - 1:1 vom Definitionsposter (Hauptwort).
   * MUESSEN print-mode.js entsprechen (Print-Match). Clother/Parlare via Typekit
   * sgc6idq, Playfair via Google. Parlare NUR Weight 400 (Glyphen-Bug). */
  var PW_STYLES = {
    modern:    { font: "'clother', sans-serif",              weight: 700 },
    elegant:   { font: "'Playfair Display', Georgia, serif", weight: 700 },
    verspielt: { font: "'parlare', cursive",                 weight: 400 }
  };
  var PW_LABEL = { modern: 'Modern', elegant: 'Elegant', verspielt: 'Verspielt' };
  function pwFont(s) { return PW_STYLES[s] || PW_STYLES.elegant; }
  var ZH_HEART_PATH = 'M 49.4 0 C 27 0, 0 24, 0 60 C 0 105, 58 166, 110 200 C 162 166, 220 105, 220 60 C 220 24, 193 0, 170.6 0 C 152 1, 116 16, 110 58 C 104 16, 68 1, 49.4 0 Z';

  /* ---- Modul-State (eine Section pro -gestalten-Page) ---- */
  var root, stage, sectionId, autocomplete;
  var state = {
    fstyle: { hero: 'verspielt' },
    hero: 'Zuhause',
    coords: 'N 52° 15′ 57.6″   E 10° 31′ 5.5″',
    names: 'Theo | Lea | Finn',
    c_hero: '#28292d',
    c_text: '#28292d',
    bg_color: '#ffffff',
    paper_size: '30x40',
    orientation: 'portrait',
    variant_id: '',
    product_type: '',
    frame_color: 'brown'
  };

  /* Dezimal -> DMS (N 52° 15′ 57.6″), Sekunden mit einer Nachkommastelle.
   * S/W-Praefixe fuer Suedhalbkugel/West. Rundungs-Uebertrag 60->0 sauber. */
  function toDMS(dec, isLat) {
    var hemi = isLat ? (dec < 0 ? 'S' : 'N') : (dec < 0 ? 'W' : 'E');
    var a = Math.abs(dec);
    var deg = Math.floor(a);
    var minFloat = (a - deg) * 60;
    var min = Math.floor(minFloat);
    var sec = Math.round((minFloat - min) * 60 * 10) / 10;
    if (sec >= 60) { sec = 0; min += 1; }
    if (min >= 60) { min = 0; deg += 1; }
    return hemi + ' ' + deg + '° ' + min + '′ ' + sec.toFixed(1) + '″';
  }
  function coordsFromLatLng(lat, lng) {
    return toDMS(lat, true) + '   ' + toDMS(lng, false);
  }

  /* ===================================================================
   * Render-Bausteine - 1:1-Spiegel von jgText/jgFit (Server print-mode.js)
   * =================================================================== */
  function zhText(grid, o) {
    if (o.content == null || String(o.content).trim() === '') return null;
    var el = document.createElement('div');
    el.className = 'text-slot';
    el.textContent = o.content;
    var css = 'position:absolute;z-index:6;' +
      'left:' + (o.x != null ? o.x : 50) + '%;top:' + o.y + '%;transform:translate(-50%,-50%);' +
      'display:flex;align-items:center;justify-content:center;text-align:center;' +
      'font-family:' + o.font + ';font-weight:' + (o.weight || 400) + ';' +
      'font-size:' + o.size + 'cqw;color:' + (o.color || INK) + ';line-height:' + (o.lh || 1.15) + ';white-space:nowrap;';
    if (o.upper) css += 'text-transform:uppercase;';
    if (o.spacing) css += 'letter-spacing:' + o.spacing + ';';
    el.style.cssText = css;
    grid.appendChild(el);
    return el;
  }

  function zhFit(el, maxPct) {
    if (!el) return;
    var avail = stage.clientWidth * (maxPct / 100);
    var guard = 0;
    while (el.scrollWidth > avail && guard < 40) {
      var cur = parseFloat(getComputedStyle(el).fontSize);
      if (!cur || cur < 2) break;
      el.style.fontSize = (cur * 0.96) + 'px';
      guard++;
    }
  }

  /* ===================================================================
   * Live-Render - 1:1-Spiegel von renderZuhause() (Server)
   * =================================================================== */
  function render() {
    if (!stage) return;
    var grid = document.createElement('div');
    grid.className = 'collage-grid no-panel';
    grid.style.setProperty('--blanket-color', state.bg_color);
    grid.style.backgroundColor = state.bg_color;

    // ---- Hero-Script (Ausschwuenge brauchen Luft -> Auto-Fit auf 84%) ----
    var elHero = zhText(grid, {
      content: (state.hero || '').trim(), x: 50, y: 44, font: pwFont(state.fstyle.hero).font, weight: pwFont(state.fstyle.hero).weight, size: 24,
      color: state.c_hero || INK, lh: 1
    });
    if (elHero) elHero.style.zIndex = 4;

    // ---- DMS-Koordinaten (verbatim aus dem Feld) ----
    var elCoords = zhText(grid, {
      content: (state.coords || '').trim(), x: 50, y: 60, font: SANS, weight: 500, size: 2.6,
      color: state.c_text || INK, spacing: '0.22em'
    });

    // ---- Herz + Namen unten ----
    var namesClean = (state.names || '').split('|').map(function (s) { return s.trim(); })
      .filter(Boolean).join('  |  ');
    if (namesClean) {
      var heart = document.createElement('div');
      heart.style.cssText = 'position:absolute;left:50%;top:72%;transform:translate(-50%,-50%);width:3cqw;z-index:5;';
      heart.innerHTML = '<svg viewBox="0 0 220 200" style="display:block;width:100%;height:auto;">' +
        '<path d="' + ZH_HEART_PATH + '" fill="' + (state.c_hero || INK) + '"/></svg>';
      grid.appendChild(heart);
    }
    var elNames = zhText(grid, {
      content: namesClean, x: 50, y: 79, font: SANS, weight: 500, size: 2.4,
      color: state.c_text || INK, upper: true, spacing: '0.24em'
    });

    stage.innerHTML = '';
    stage.appendChild(grid);

    zhFit(elHero, 84);
    zhFit(elCoords, 88);
    zhFit(elNames, 88);
  }

  /* ===================================================================
   * Adresssuche - Google Places Autocomplete (Apparel-Muster, Retry
   * bis die API geladen ist). Treffer -> Dezimal->DMS ins Feld.
   * Kein Treffer/API-Ausfall -> Feld bleibt manuell editierbar (Fallback).
   * =================================================================== */
  function initAutocomplete() {
    if (autocomplete) return;
    if (typeof google === 'undefined' || !google.maps || !google.maps.places) {
      setTimeout(initAutocomplete, 250);
      return;
    }
    var search = document.getElementById('zh-search');
    if (!search) return;
    autocomplete = new google.maps.places.Autocomplete(search, {
      fields: ['geometry', 'formatted_address', 'name'],
      types: ['geocode']
    });
    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (!place || !place.geometry) return;
      var lat = place.geometry.location.lat();
      var lng = place.geometry.location.lng();
      state.coords = coordsFromLatLng(lat, lng);
      var coordsInput = document.getElementById('zh-coords');
      if (coordsInput) coordsInput.value = state.coords;
      render();
    });
  }

  /* ===================================================================
   * Eingaben
   * =================================================================== */
  function bindField(id, key) {
    var el = document.getElementById(id);
    if (!el) return;
    if (el.value != null) state[key] = el.value;
    el.addEventListener('input', function () { state[key] = el.value; render(); });
  }

  /* ===================================================================
   * Bewohner-Namen als Add-Rows (Muster jahreszahlen.js) - min 1, max 6.
   * State bleibt der '|'-gejointe String -> render(), Cart-Payload und
   * Server (rendert verbatim) bleiben UNVERAENDERT.
   * =================================================================== */
  var ZH_MAX_NAMES = 6, ZH_MIN_NAMES = 1;
  function zhSyncNamesState() {
    var vals = [];
    root.querySelectorAll('#zh-names-rows .zh-name').forEach(function (inp) {
      if (inp.value.trim()) vals.push(inp.value.trim());
    });
    state.names = vals.join(' | ');
  }
  function zhUpdateNameControls() {
    var rows = root.querySelectorAll('#zh-names-rows .zh-name-row');
    var addBtn = document.getElementById('zh-add-name');
    if (addBtn) addBtn.style.display = rows.length >= ZH_MAX_NAMES ? 'none' : '';
    rows.forEach(function (r) {
      var rm = r.querySelector('.zh-remove');
      if (rm) rm.style.visibility = rows.length <= ZH_MIN_NAMES ? 'hidden' : 'visible';
    });
  }
  function initNamesEditor() {
    var wrap = document.getElementById('zh-names-rows');
    if (!wrap) return;
    wrap.addEventListener('input', function (e) {
      if (e.target.classList.contains('zh-name')) { zhSyncNamesState(); render(); }
    });
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.zh-remove');
      if (!btn) return;
      e.preventDefault();
      if (wrap.querySelectorAll('.zh-name-row').length <= ZH_MIN_NAMES) return;
      btn.closest('.zh-name-row').remove();
      zhUpdateNameControls();
      zhSyncNamesState();
      render();
    });
    var addBtn = document.getElementById('zh-add-name');
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (wrap.querySelectorAll('.zh-name-row').length >= ZH_MAX_NAMES) return;
        var row = document.createElement('div');
        row.className = 'zh-name-row';
        row.innerHTML = '<input type="text" class="zh-name" maxlength="15" autocomplete="off" placeholder="Vorname">' +
          '<button type="button" class="zh-remove" aria-label="Namen entfernen">&times;</button>';
        wrap.appendChild(row);
        zhUpdateNameControls();
        var inp = row.querySelector('.zh-name');
        if (inp) inp.focus();
      });
    }
    zhUpdateNameControls();
    zhSyncNamesState();   // Markup-Rows = Source of Truth (Playbook §1)
  }

  function initStylePickers() {
    root.querySelectorAll('.pw-style-row[data-style-target]').forEach(function (row) {
      var target = row.getAttribute('data-style-target');
      var btns = row.querySelectorAll('.pw-style-btn[data-style]');
      var cur = row.querySelector('.pw-style-btn.current[data-style]');
      if (cur) state.fstyle[target] = cur.dataset.style;
      btns.forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          btns.forEach(function (x) { x.classList.remove('current'); });
          b.classList.add('current');
          state.fstyle[target] = b.dataset.style;
          render();
        });
      });
    });
  }

  function initColorPickers() {
    root.querySelectorAll('.zh-color[data-key]').forEach(function (p) {
      if (p.value) state[p.dataset.key] = p.value;
      p.addEventListener('input', function () { state[p.dataset.key] = p.value; render(); });
    });
  }

  function initPaperColor() {
    var swatches = root.querySelectorAll('.zh-paper[data-color]');
    function setPaper(hex) {
      state.bg_color = hex;
      swatches.forEach(function (s) {
        s.classList.toggle('current', (s.getAttribute('data-color') || '').toLowerCase() === hex.toLowerCase());
      });
      render();
    }
    swatches.forEach(function (s) {
      s.addEventListener('click', function (e) { e.preventDefault(); setPaper(s.getAttribute('data-color')); });
    });
  }

  /* Info-Gluehbirne (Stadt-/Sternkarten-Muster, .tab-help) */
  function initTabHelp() {
    root.querySelectorAll('.tab-help').forEach(function (help) {
      var toggle = help.querySelector('.tab-help__toggle');
      var content = help.nextElementSibling;
      if (!toggle || !content || !content.classList.contains('tab-help__content')) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var open = content.style.display === 'none' || content.style.display === '';
        content.style.display = open ? 'block' : 'none';
        toggle.classList.toggle('is-active', open);
      });
      var close = content.querySelector('.tab-help__close a');
      if (close) {
        close.addEventListener('click', function (e) {
          e.preventDefault();
          content.style.display = 'none';
          toggle.classList.remove('is-active');
        });
      }
    });
  }

  /* Tabs (Design / Produkt) - main__switcher-Konvention */
  var formatDefaulted = false;
  function initTabSwitching() {
    var tabs = root.querySelectorAll('.main__switcher > ul > li > a[data-tab]');
    var panels = ['text__wrapper', 'produkt__wrapper'];
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('current'); });
        tab.classList.add('current');
        panels.forEach(function (cls) {
          var el = root.querySelector('.' + cls);
          if (el) el.style.display = (cls === target) ? '' : 'none';
        });
        // Produkt-Tab-Default (Dominik 21.07.): erster Klick -> Holzrahmen (data-id=2);
        // Schwarz + 50x70 sind im Markup bereits .current, fallen damit automatisch.
        if (target === 'produkt__wrapper' && !formatDefaulted) {
          formatDefaulted = true;
          var framed = root.querySelector('.tab__switcher a[data-id="2"]:not(.current)');
          if (framed) framed.click();
        }
        // Mobiles Hochscrollen zur Tab-Leiste (nur <=991px), alle Optionen sichtbar.
        if (window.matchMedia('(max-width: 991px)').matches) {
          var sw = tab.closest('.main__switcher');
          if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
  function initWeiterNav() {
    root.querySelectorAll('.weiter-btn[data-target-tab]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var link = root.querySelector('.main__switcher > ul > li > a[data-tab="' + btn.dataset.targetTab + '"]');
        if (link) link.click();
      });
    });
  }

  /* ===================================================================
   * Produkt-Tab - 1:1 Geburtsposter-Schema, ABER orientierungs-treu:
   * Groessen-Label bestimmt Hoch-/Querformat (keine min/max-Normalisierung).
   * =================================================================== */
  function parsePosterDim(label) {
    var m = /([0-9]+)\s*x\s*([0-9]+)/i.exec(label || '');
    return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : { w: 30, h: 40 };
  }
  /* Label + Orientation-Toggle -> effektive Print-Dims (photo.js-Muster:
   * bei Landscape lange Seite = width, gleiche Variante/SKU). */
  function effectiveDim() {
    var d = parsePosterDim(state.paper_size);
    var lo = Math.max(d.w, d.h), sh = Math.min(d.w, d.h);
    return state.orientation === 'landscape' ? { w: lo, h: sh } : { w: sh, h: lo };
  }
  function formatPrice(cents) {
    return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ',');
  }
  function syncStageToSize() {
    if (!stage || !state.paper_size) return;
    var d = effectiveDim();
    stage.style.setProperty('--collage-aspect', d.w + ' / ' + d.h);
    var flat = stage.closest('.zh-stage-flat');
    if (flat) flat.style.width = 'calc(min(78vh, 680px) * ' + (d.w / d.h) + ')';
    render();
  }
  function initOrientationPicker() {
    var buttons = root.querySelectorAll('.orientation-picker li a');
    if (!buttons.length) return;
    var current = root.querySelector('.orientation-picker li a.current');
    if (current) state.orientation = current.dataset.orientation || 'portrait';
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        buttons.forEach(function (b) { b.classList.remove('current'); });
        btn.classList.add('current');
        state.orientation = btn.dataset.orientation || 'portrait';
        syncStageToSize();
      });
    });
  }
  function syncVariantFromSize(a) {
    state.paper_size = a.getAttribute('data-size') || '';
    state.variant_id = a.getAttribute('data-variant-id') || '';
    var variantInput = document.getElementById('zh-variant-id-' + sectionId);
    if (variantInput && state.variant_id) variantInput.value = state.variant_id;
    var priceEl = root.querySelector('.bottom__controls .variant-price');
    var cents = a.getAttribute('data-price');
    if (priceEl && cents) { priceEl.textContent = formatPrice(cents) + ' €'; priceEl.dataset.price = cents; }
    syncStageToSize();
  }
  function updateFramePreview() {
    if (!stage) return;
    var framed = (state.product_type || '').indexOf('Holzrahmen') !== -1;
    if (framed) { stage.classList.add('has-frame'); stage.setAttribute('data-frame-color', state.frame_color || 'brown'); }
    else { stage.classList.remove('has-frame'); stage.removeAttribute('data-frame-color'); }
  }

  function initFormatPickers() {
    var typeLinks = root.querySelectorAll('.tab__switcher a[data-id]');
    var sizeLinks = root.querySelectorAll('.el__format .size__picker a[data-size]');
    var frameLinks = root.querySelectorAll('a[data-frame-color]');

    typeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        typeLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.product_type = a.getAttribute('data-type') || '';
        var typeId = a.getAttribute('data-id');
        updateFramePreview();
        root.querySelectorAll('.el__format').forEach(function (f) {
          f.style.display = (f.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        root.querySelectorAll('.benefits-box').forEach(function (b) {
          b.style.display = (b.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        var fmt = root.querySelector('.el__format[data-id="' + typeId + '"]');
        if (!fmt) return;
        var ziel = fmt.querySelector('.size__picker a[data-size="' + state.paper_size + '"]') ||
                   fmt.querySelector('.size__picker a.current') ||
                   fmt.querySelector('.size__picker a[data-size]');
        if (ziel) {
          fmt.querySelectorAll('.size__picker a').forEach(function (l) { l.classList.remove('current'); });
          ziel.classList.add('current');
          syncVariantFromSize(ziel);
        }
      });
    });

    sizeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var picker = a.closest('.size__picker');
        picker.querySelectorAll('a').forEach(function (l) { l.classList.remove('current'); });
        a.classList.add('current');
        syncVariantFromSize(a);
      });
    });

    frameLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        frameLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.frame_color = a.getAttribute('data-frame-color');
        updateFramePreview();
      });
    });

    var activeType = root.querySelector('.tab__switcher a.current[data-type]') || typeLinks[0];
    if (activeType) state.product_type = activeType.getAttribute('data-type') || '';
    var activeFrame = root.querySelector('a[data-frame-color].current');
    if (activeFrame) state.frame_color = activeFrame.getAttribute('data-frame-color');
    var visFormat = root.querySelector('.el__format[data-id="1"]');
    var activeSize = visFormat && (visFormat.querySelector('.size__picker a.current') || visFormat.querySelector('.size__picker a[data-size]'));
    if (activeSize) {
      if (!activeSize.classList.contains('current')) activeSize.classList.add('current');
      syncVariantFromSize(activeSize);
    }
    updateFramePreview();
  }

  /* ===================================================================
   * Cart-Add - Muster geburtsposter.js: Render-Job synchron anstossen,
   * dann /cart/add.js mit _print_image_url + Config-Properties.
   * =================================================================== */
  function handleCartAdd() {
    var btn = document.getElementById('zh-cart-btn-' + sectionId);
    if (!(state.hero || '').trim()) { alert('Bitte gib einen Schriftzug ein.'); return; }
    if (!(state.coords || '').trim()) { alert('Bitte suche deine Adresse oder trage Koordinaten ein.'); return; }
    if (!state.variant_id) { alert('Bitte waehle Produkt und Groesse.'); return; }
    var orig = btn ? btn.textContent : 'In den Warenkorb';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird vorbereitet...'; }

    (async function () {
      try {
        var jobId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2));
        var d = effectiveDim();
        var namesClean = (state.names || '').split('|').map(function (s) { return s.trim(); })
          .filter(Boolean).join('  |  ');

        var payload = {
          product: 'zuhause',
          job_id: jobId,
          variant_id: state.variant_id,
          paper_size: state.paper_size,
          print: { width: d.w, height: d.h, dpi: 300 },   // effektive Dims (Toggle beruecksichtigt)
          orientation: state.orientation,
          font_styles: state.fstyle,
          bg_color: state.bg_color,
          hero: (state.hero || '').trim(),
          coords: (state.coords || '').trim(),
          names: namesClean,
          c_hero: state.c_hero || INK,
          c_text: state.c_text || INK
        };

        var printImageUrl = BACKEND_API_URL + '/api/v1/zuhause/data/' + jobId + '/';
        try {
          var renderResp = await fetch(BACKEND_API_URL + '/api/v1/zuhause/render/', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
          });
          if (renderResp.ok || renderResp.status === 202) {
            var rd = await renderResp.json().catch(function () { return {}; });
            printImageUrl = rd.print_image_url || printImageUrl;
          }
        } catch (e) { /* Backend nicht erreichbar -> Fallback-URL bleibt */ }

        var props = {
          '_Schriftzug': (state.hero || '').trim(),
          '_Koordinaten': (state.coords || '').trim(),
          '_job_id': jobId,
          '_print_image_url': printImageUrl,
          '_groesse': d.w + 'x' + d.h,
          '_Ausrichtung': state.orientation === 'landscape' ? 'Querformat' : 'Hochformat',
          '_Stil': PW_LABEL[state.fstyle.hero] || 'Verspielt',
          '_produkt': 'zuhause'
        };
        if (namesClean) props['_Namen'] = namesClean;
        if (state.frame_color && (state.product_type || '').indexOf('Holzrahmen') !== -1) {
          props['_Frame Color'] = state.frame_color;
        }
        Object.keys(props).forEach(function (k) { if (!props[k]) delete props[k]; });

        var cartResp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(state.variant_id, 10), quantity: 1, properties: props }] })
        });
        if (!cartResp.ok) throw new Error('Cart-Add HTTP ' + cartResp.status);

        var cartData = null;
        try {
          cartData = await cartResp.json();
          if (window.DLTrack && window.DLTrack.addToCart) window.DLTrack.addToCart(cartData);
        } catch (e) { /* skip tracking */ }

        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cartData } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        else window.location.href = '/cart';
      } catch (err) {
        console.error('[zuhause] Cart-add failed', err);
        alert('Konnte nicht in den Warenkorb legen - ' + (err.message || 'Unbekannter Fehler'));
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = orig || 'In den Warenkorb'; }
      }
    })();
  }

  /* ===================================================================
   * Init - Input-Values aus dem Markup sind Source of Truth (Playbook §1)
   * =================================================================== */
  function init() {
    root = document.querySelector('.zh-customizer');
    if (!root) return;
    sectionId = root.dataset.sectionId;
    stage = document.getElementById('zh-stage-' + sectionId);

    bindField('zh-hero', 'hero');
    bindField('zh-coords', 'coords');
    initAutocomplete();
    initNamesEditor();
    initStylePickers();
    initColorPickers();
    initPaperColor();
    initTabHelp();
    initTabSwitching();
    initWeiterNav();
    initOrientationPicker();
    initFormatPickers();

    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);

    var btn = document.getElementById('zh-cart-btn-' + sectionId);
    if (btn) btn.addEventListener('click', handleCartAdd);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
